export default __webpack_public_path__ + "static/media/card2.2cf19772.webp";